"use strict";
exports.eachWeekendOfInterval = eachWeekendOfInterval;
var _index = require("./eachDayOfInterval.js");
var _index2 = require("./isWeekend.js");
function eachWeekendOfInterval(interval) {
  const dateInterval = (0, _index.eachDayOfInterval)(interval);
  const weekends = [];
  let index = 0;
  while (index < dateInterval.length) {
    const date = dateInterval[index++];
    if ((0, _index2.isWeekend)(date)) weekends.push(date);
  }
  return weekends;
}
